import React, { useState, useEffect } from 'react';
import './Hero.css';
import OrderNowButton from './OrderNowButton';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slides, setSlides] = useState([]);
  
  useEffect(() => {
    // Function to import all images from the food folder
    const importAllImages = () => {
      try {
        // Use webpack's require.context to get all files from the food folder
        const context = require.context('../assets/food', false, /\.(jpeg|jpg|png|gif|webp)$/i);
        const imageModules = context.keys().map((key, index) => ({
          id: index + 1,
          image: context(key),
          alt: `Food presentation - ${key.replace('./', '').replace(/\.(jpeg|jpg|png|gif|webp)$/i, '')}`
        }));
        setSlides(imageModules);
      } catch (error) {
        console.error('Error loading food images:', error);
      }
    };

    importAllImages();
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;

    const timer = setInterval(() => {
      setIsTransitioning(true);
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setTimeout(() => setIsTransitioning(false), 50);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img src={slide.image} alt={slide.alt} />
          </div>
        ))}
      </div>
      <div className="hero-content">
        <div className="hero-text">
          <span className="hero-subtitle">Best Sports Bar in San Carlos</span>
          <h1 className="hero-title">Welcome Sports Fans!</h1>
          <div className="hero-cta-container">
            <OrderNowButton theme="light" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 